<template>
  <div class="uk-container uk-margin-small-top">
    <h2 class="uk-heading-small uk-text-center">
      Describe Your Design or Pick From Patterns
    </h2>
    <p class="uk-text-center uk-width-1-2@m uk-align-center">
      Select the patterns and designs you would like to customize. Pick up to
      {{ maxSelections }} styles for our designers to use as a starting point.
      Next you'll be able to select colors and upload a logo.
    </p>
    <progress
      class="uk-progress uk-width-1-2@m uk-align-center"
      :value="onboardingConfig.completedSteps"
      :max="onboardingConfig.totalSteps"
      uk-tooltip="Step 1/3"
    ></progress>
    <h3 class="uk-text-center uk-width-1-2@m uk-align-center">
      Describe your design:
    </h3>
    <div class="uk-width-1-2@m uk-align-center">
      <textarea
        class="uk-textarea uk-align-center"
        rows="5"
        v-model="tempCustomRequest"
      ></textarea>
    </div>
    <div class="uk-align-center" id="stick-width">
      <div
        class="uk-card uk-card-small uk-margin uk-card-default uk-card-body"
        uk-sticky=" bottom: #offset; width-element: #sticky-width; animation: uk-animation-slide-top; show-on-up: true;"
      >
        <div class="uk-width-1-2@m uk-align-center uk-margin-remove-bottom">
          <div class="uk-child-width-1-2" uk-grid>
            <div>
              <router-link to="/new-project/distributors">
                <button
                  class="uk-button uk-button-default uk-width-1-1 uk-margin-remove-bottom"
                >
                  Go Back
                </button>
              </router-link>
            </div>
            <div>
              <router-link to="/new-project/distributors/upload-logo">
                <button
                  class="uk-button uk-button-primary uk-align-right uk-width-1-1 uk-margin-remove-bottom"
                  v-if="canContinue"
                  v-on:click="setSelectedStyles()"
                >
                  Continue
                </button>
              </router-link>
              <button
                class="uk-button uk-button-primary uk-align-right uk-width-1-1"
                v-if="!canContinue"
                disabled
              >
                Make a selection
              </button>
            </div>
          </div>
        </div>
        <p class="uk-margin-remove-bottom uk-text-small uk-text-muted">
          <center>Selected: {{ selectedProductCounts.total }}/8</center>
        </p>
        <ul uk-tab class="uk-flex-center uk-margin-remove-top">
          <li
            v-bind:class="{ 'uk-active': displayTies }"
            v-on:click="setCurrentProductView('tie')"
          >
            <a href>
              Ties
              <span v-if="selectedProductCounts.ties > 0"
                >({{ selectedProductCounts.ties }})</span
              >
            </a>
          </li>
          <li
            v-bind:class="{ 'uk-active': displayBowTies }"
            v-on:click="setCurrentProductView('bowTie')"
          >
            <a href>
              Bow Ties
              <span v-if="selectedProductCounts.bowTies > 0"
                >({{ selectedProductCounts.bowTies }})</span
              >
            </a>
          </li>
          <li
            v-bind:class="{ 'uk-active': displayPocketSquares }"
            v-on:click="setCurrentProductView('pocketSquare')"
          >
            <a href>
              Pocket Squares
              <span v-if="selectedProductCounts.pocketSquares > 0"
                >({{ selectedProductCounts.pocketSquares }})</span
              >
            </a>
          </li>
          <li
            v-bind:class="{ 'uk-active': displayInfinityScarves }"
            v-on:click="setCurrentProductView('infinityScarf')"
          >
            <a href>
              Infinity Scarves
              <span v-if="selectedProductCounts.infinityScarves > 0"
                >({{ selectedProductCounts.infinityScarves }})</span
              >
            </a>
          </li>
          <li
            v-bind:class="{ 'uk-active': displayChiffonScarves }"
            v-on:click="setCurrentProductView('chiffonScarf')"
          >
            <a href>
              Chiffon Scarves
              <span v-if="selectedProductCounts.rectangleScarves > 0"
                >({{ selectedProductCounts.chiffonScarves }})</span
              >
            </a>
          </li>
          <li
            v-bind:class="{ 'uk-active': displayGaiters }"
            v-on:click="setCurrentProductView('neckGaiter')"
          >
            <a href>
              Neck Gaiters
              <span v-if="selectedProductCounts.neckGaiters > 0"
                >({{ selectedProductCounts.neckGaiters }})</span
              >
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="uk-child-width-1-2 uk-child-width-1-4@m" uk-grid>
      <div v-for="pattern in displayedProducts">
        <div
          class="uk-card uk-card-default uk-card-small uk-margin-medium-bottom"
          id="card"
        >
          <div
            class="uk-card-media-top"
            v-on:click="setZoomImage(pattern)"
            uk-toggle="target: #zoom-image"
          >
            <a href="#">
              <img :src="pattern.image" alt />
            </a>
          </div>
          <div class="uk-card-body">
            <h4 class="uk-card-title uk-margin-small-bottom">
              <center>{{ pattern.patternName }}</center>
            </h4>
            <p
              class="uk-margin-small-bottom uk-margin-remove-top uk-text-muted"
            >
              <center>{{ _.startCase(pattern.productType) }}</center>
            </p>
            <button
              v-if="!styleIsSelected(pattern) && !maxSelected"
              v-on:click="selectStyle(pattern)"
              class="uk-button uk-button-default uk-margin-remove uk-width-1-1"
            >
              Select
            </button>
            <button
              v-if="styleIsSelected(pattern)"
              v-on:click="deselectStyle(pattern)"
              class="uk-button uk-button-primary uk-margin-remove uk-width-1-1"
            >
              remove
            </button>
            <button
              v-if="maxSelected && !styleIsSelected(pattern)"
              class="uk-button uk-button-default uk-margin-remove uk-width-1-1"
              disabled
            >
              maximum selected
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="zoom-image" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-width-auto uk-margin-auto-vertical">
        <button class="uk-modal-close-outside" type="button" uk-close></button>
        <img :src="zoomImage" alt />
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import OrgPatternService from "@/services/OrgPatternService";
import firebase from "firebase";

export default {
  name: "SelectDistStyles",
  data() {
    return {
      onboardingConfig: {
        formType: "distributor",
        completedSteps: 1,
        totalSteps: 4
      },
      patterns: [],
      currentProductView: "tie",
      tempSelectedStyles: [],
      tempCustomRequest: "",
      zoomImage: "",
      maxSelections: 8
    };
  },
  methods: {
    setCurrentProductView(product) {
      this.currentProductView = product;
    },
    styleIsSelected(pattern) {
      var self = this;
      for (var i = 0; i < this.tempSelectedStyles.length; i++) {
        if (
          self.tempSelectedStyles[i].patternName == pattern.patternName &&
          self.tempSelectedStyles[i].productType == pattern.productType
        ) {
          return true;
        }
      }
    },
    selectStyle(pattern) {
      var self = this;
      self.tempSelectedStyles.push(pattern);
    },
    deselectStyle(pattern) {
      var self = this;
      for (var i = 0; i < self.tempSelectedStyles.length; i++) {
        if (self.tempSelectedStyles[i] == pattern) {
          self.tempSelectedStyles.splice(i, 1);
        }
      }
    },
    setZoomImage(pattern) {
      this.zoomImage = pattern.image;
    },
    setSelectedStyles() {
      this.$store.commit(
        "newDistProject/setSelectedStyles",
        this.tempSelectedStyles
      );
      this.$store.commit(
        "newDistProject/setCustomRequest",
        this.tempCustomRequest
      );
    },
    getPatterns() {
      var self = this;
      self.patterns = [];
      firebase
        .firestore()
        .collection("orgPatterns")
        .orderBy("patternName")
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            // doc.data() is never undefined for query doc snapshots
            let data = doc.data();
            let pattern = {
              patternName: data.patternName,
              image: data.image,
              productType: data.productType,
              id: doc.id
            };
            self.patterns.push(pattern);
          });
        });
    }
  },
  computed: {
    isActive() {
      return this.$store.state.newDistProject.isActive;
    },
    displayedProducts() {
      var self = this;
      var currentPatterns = [];
      for (var i = 0; i < self.patterns.length; i++) {
        if (
          self.patterns[i].productType == _.camelCase(self.currentProductView)
        ) {
          currentPatterns.push(self.patterns[i]);
        }
      }
      return currentPatterns;
    },
    displayTies() {
      return this.currentProductView == "tie";
    },
    displayBowTies() {
      return this.currentProductView == "bowTie";
    },
    displayPocketSquares() {
      return this.currentProductView == "pocketSquare";
    },
    displayChiffonScarves() {
      return this.currentProductView == "chiffonScarf";
    },
    displayInfinityScarves() {
      return this.currentProductView == "infinityScarf";
    },
    displayInfinityScarves() {
      return this.currentProductView == "neckGaiter";
    },
    selectedProductCounts() {
      var self = this;
      var selectedCounts = {
        ties: 0,
        bowTies: 0,
        pocketSquares: 0,
        infinityScarves: 0,
        rectangleScarves: 0,
        squareScarves: 0,
        neckGaiter: 0,
        total: 0
      };
      for (var i = 0; i < self.tempSelectedStyles.length; i++) {
        self.tempSelectedStyles[i];
        if (self.tempSelectedStyles[i].productType == "tie") {
          selectedCounts.ties += 1;
        } else if (self.tempSelectedStyles[i].productType == "bowTie") {
          selectedCounts.bowTies += 1;
        } else if (self.tempSelectedStyles[i].productType == "pocketSquare") {
          selectedCounts.pocketSquares += 1;
        } else if (self.tempSelectedStyles[i].productType == "infinityScarf") {
          selectedCounts.infinityScarves += 1;
        } else if (self.tempSelectedStyles[i].productType == "chiffonScarf") {
          selectedCounts.rectangleScarves += 1;
        } else if (self.tempSelectedStyles[i].productType == "neckGaiter") {
          selectedCounts.neckGaiter += 1;
        }
        selectedCounts.total += 1;
      }
      return selectedCounts;
    },
    maxSelected() {
      var self = this;
      if (self.selectedProductCounts.total == self.maxSelections) {
        return true;
      } else {
        return false;
      }
    },
    canContinue() {
      var self = this;
      if (self.selectedProductCounts.total > 0 || self.designIdeas != "") {
        return true;
      }
    },
    selectedStyles() {
      return this.$store.state.newDistProject.selectedStyles.styles;
    },
    customRequest() {
      return this.$store.state.newDistProject.selectedStyles.custom;
    }
  },
  mounted: function() {
    if (!this.isActive) {
      this.$router.push({ name: "CreateDistProject" });
    }
    if (this.$store.state.newDistProject.selectedStyles.saved == true) {
      this.tempSelectedStyles = JSON.parse(JSON.stringify(this.selectedStyles));
      this.tempCustomRequest = this.customRequest.toString();
    }
    this.getPatterns();
  }
};
</script>

<style type="text/css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/distributor-onboarding/SelectDistStyles.vue